// extracted by mini-css-extract-plugin
module.exports = {"h1pxftsm":"h1pxftsm","w1h7eatl":"w1h7eatl","b1q27bnp":"b1q27bnp"};